import { Injectable } from '@angular/core';

export interface Toast {
  body: string;
  icon?: string;
  delay?: number;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toasts: Toast[] = [];

  show(body: string, icon?: string) {
    this.toasts.push({ body, icon });
  }

  remove(toast: Toast) {
    this.toasts = this.toasts.filter((t) => t != toast);
  }
}
